export { default as Goods } from './Goods'



// WEBPACK FOOTER //
// ./src/Catalog/components/index.js